module.exports = __webpack_public_path__ + "images/261af73a01df794652ddb11ecac4b60a.svg";